@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/custom-suggestions-option' as *;
@use '../@shared/custom-suggestions-options-group' as *;
@use '../@shared/custom-suggestions-toggle' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;
@use '../@shared/input.mixin' as *;
@use '../@shared/mixins' as *;
@use '../@shared/button.mixin' as *;
@use '../@shared/icon.mixin' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-custom-suggestions-option;
	@include kol-custom-suggestions-options-group;
	@include kol-custom-suggestions-toggle;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;
	@include kol-icon-styles();

	$option-height: to-rem(40);
	$visible-options: var(--visible-options, 5);

	.kol-single-select {
		&__delete {
			@include kol-button-styles('kol-button');
		}

		&__no-results-message {
			display: flex;
			min-height: to-rem(50);
			align-items: center;
			justify-content: center;
			cursor: default;
		}

		.kol-custom-suggestions-options-group {
			max-height: calc($option-height * $visible-options + to-rem(2)) !important;
		}
	}

	.kol-custom-suggestions-toggle {
		&:not(&--disabled) {
			cursor: pointer;
		}

		&--disabled {
			opacity: 0.5;
		}
	}
}
